import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CognitoCookieService } from '@callrail/looky/core';
import { LocationService } from '@callrail/looky/util';
import { PostLoginService } from '../../services/post-login/post-login.service';

@Component({
  selector: 'anbs-amplify-redirect',
  template: '',
  standalone: false,
})
export class AmplifyRedirectComponent implements OnInit {
  @Input() redirectType = 'auth';
  @Input() remember = false;
  @Output() redirect = new EventEmitter<boolean>();

  private readonly locationService = inject(LocationService);
  private readonly cognitoCookieService = inject(CognitoCookieService);
  private readonly postLoginService = inject(PostLoginService);
  private readonly route = inject(ActivatedRoute);

  ngOnInit() {
    if (this.redirectType === 'dev') {
      this.cognitoCookieService.resetUserSignedOut();
      this.locationService.go('/', true);
      return;
    }

    this.postLoginService.redirect(this.route.snapshot.queryParamMap);
  }
}
